import React from 'react'
import { StyleSheet, View, TouchableOpacity, TouchableWithoutFeedback } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'

import { colors, hexColorToRGBa } from '../../../styles/global'
import { setPreConfigTaskModalData } from '../../../../redux/actions'
import PreConfigTaskGeneratorModal from './PreConfigTaskGeneratorModal'
import RunOutOfGoldAssistantModal from '../../../ChatsView/ChatDV/EditorView/BotOption/RunOutOfGoldAssistantModal'
import { isModalOpen, MENTION_MODAL_ID } from '../../../ModalsManager/modalsManager'
import useSafeAreaOverlayPadding from '../../../../hooks/useSafeAreaOverlayPadding'

export default function GlobalPreConfigTaskModal() {
    const safeAreaOverlayPadding = useSafeAreaOverlayPadding()
    const dispatch = useDispatch()
    const preConfigTaskModalData = useSelector(state => state.preConfigTaskModalData)
    const gold = useSelector(state => state.loggedUser.gold)
    const { visible, task, assistant, projectId } = preConfigTaskModalData

    const closeModal = () => {
        if (isModalOpen(MENTION_MODAL_ID)) return
        dispatch(setPreConfigTaskModalData(false, null, null, null))
    }

    // Only require assistant.uid since PreConfigTaskGeneratorModal uses assistant.uid
    if (!visible || !task || !assistant?.uid || !projectId) {
        return null
    }

    return (
        <View style={[localStyles.overlay, safeAreaOverlayPadding]}>
            <TouchableWithoutFeedback onPress={closeModal}>
                <View style={localStyles.backdrop} />
            </TouchableWithoutFeedback>
            <View style={localStyles.modalContainer}>
                {gold > 0 ? (
                    <PreConfigTaskGeneratorModal
                        projectId={projectId}
                        closeModal={closeModal}
                        task={task}
                        assistant={assistant}
                    />
                ) : (
                    <RunOutOfGoldAssistantModal closeModal={closeModal} />
                )}
            </View>
        </View>
    )
}

const localStyles = StyleSheet.create({
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10000,
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdrop: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: hexColorToRGBa(colors.Text03, 0.24),
    },
    modalContainer: {
        zIndex: 10000,
    },
})
